import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData } from '../utils';
import * as AuthStore from "../store/Auth";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { fngr } from '../img';
import { Table, Select, Input, Button, Tabs, Row, Col, message, Card, List, Form, Divider } from 'antd';
import { SearchOutlined, EyeOutlined, BarsOutlined, CloseCircleOutlined } from '@ant-design/icons/lib';
const { TabPane } = Tabs;
const { Option } = Select;
const { Item } = Form;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class LimsManifest extends React.Component<AuthProps>
{
    public state =
        {
            clientSite: false,
            siteId: 0,
            loading: false,
            manifest:
            {
                id: 0,
                facilityId: 0,
                manifestId: '',
                sampleSpace: '',
                testType: '',
                referringLabState: '',
                referringLabLga: '',
                dateScheduleForPickup: '',
                samplePickUpOnTime: '',
                riderTotalSamplesPicked: 0,
                riderTempAtPickUp: '',
                riderName: '',
                riderPhoneNumber: '',
                pcrLabName: '',
                pcrLabCode: '',
                resultStatus: '',
                dateCreated: '',
                createdBy: '',
                dateModified: '',
                modifiedBy: '',
                feedback: '',
                manifestSamples: [],
                manifestResults: []
            },
            searchText: "",
            visible: false,
            selected: false,
            states: [],
            manifests: [],
            showDetails: false,
            site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
            state: { stateId: 0, stateName: '', stateCode: '', sites: [] },
            searchObj:
            {
                state: '',
                site: 0,
                siteName: '',
                stateName: ''
            },
            careVisible: false,
            labVisible: false,
            htsVisible: false,
            pagination:
            {
                current: 1,
                total: 0,
                pageSize: 10,
                sorter: {
                    field: "name",
                    order: "asc"
                }
            }
        };

    ////@ts-ignore
    async componentDidMount() {
        let el = this;

        var loginForm = document.getElementById("srchDv");
        if (loginForm && loginForm !== null) {
            loginForm.addEventListener("keyup", function (event) {
                var elm = document.getElementById("searchBtnP");
                if (event.keyCode === 13 && elm) {
                    event.preventDefault();
                    elm.click();
                }
            });
        }

        let user = el.props.appUser;
        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0) {
            var statex = states.filter(s => {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }

    selectSite(value: any) {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.state.sites.filter(function (o: any) { return o.id === searchObj.site });
            if (sites.length > 0) {
                searchObj.siteName = sites[0].name;
                this.setState({ searchObj, site: sites[0] });
            }

            console.log(sites);
        }
    }

    selectState(value: any) {
        var el = this;
        if (!value) {
            return;
        }

        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

    textChange(e: any) {
        this.setState({ searchText: e.target.value });
    }

    handleTableChange(pagination: any, filters: any, sorter: any) {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems();
    }

    async getItems() {
        let el = this;
        const { pagination, site } = el.state;

        this.setState({ loading: true });
        var searchText = el.state.searchText;
        var results = pagination.pageSize;
        var page = pagination.current;

        var query = `/api/Site/getManifests?siteId=${site.id}&itemsPerPage=${results}&pageNumber=${page}&term=${searchText}`;

        let res = await fetchData(query);

        pagination.total = res.totalItems;
        el.setState({
            manifests: res.manifests,
            pagination,
            loading: false
        });

        if (searchText && searchText.trim().length > 0) {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.manifests.map((record: any) => {
                    const match = record.manifestId.toString().match(reg);

                    if (!match) {
                        return null;
                    }
                    return {
                        ...record,
                        name: (<span> {record.manifestId.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }

    ////@ts-ignore
    async getManifestSamples(data: any) {
        let el = this;
        if (data.id < 1) {
            message.error("Invalid selection");
            return;
        }
        var query = `/api/Site/getManifestSamples?manifestId=` + data.id;
        el.setState({ loading: true, showDetails: false });
        let manifestSamples = await fetchData(query);
        el.setState({ loading: false });
        if (manifestSamples.length > 0) {
            data.manifestSamples = manifestSamples;
            el.setState({ manifest: data, showDetails: true });
        }
        else {
            message.error('Manifest information could not be retrieved');
        }
    }
    handleChange(value: any) {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems();
    }
    exit() {
        this.setState({
            showDetails: false
        });
    }
    onInputChange(e: any) {
        let searchTerm = e.target.value.trim();
        this.setState({ searchText: searchTerm });
    }

    onSearch() {
        let el = this;
        if (!el.state.searchText || el.state.searchText.length < 1) {
            message.error('Please provide a Manifest ID');
            return;
        }
        el.getItems();
    }
    render() {
        const { searchText, manifest, manifests, loading, showDetails, state, states, searchObj } = this.state;
        let el = this;
        let user = el.props.appUser;

        const columns =
            [
                //{
                //    title: 'State',
                //    dataIndex: 'stateCode',
                //    key: 'stateCode',
                //    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                //},
                //{
                //    title: 'Facility',
                //    dataIndex: 'name',
                //    key: 'name',
                //    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                //},
                {
                    title: 'Manifest Id',
                    dataIndex: 'manifestId',
                    key: 'manifestId',
                    render: (value: any, row: any, index: any) => <a className="anchor-action db-h3-b" key={row.id} title="View Details" onClick={() => el.getManifestSamples(row)} style={{ cursor: 'pointer' }}><span >{row.manifestId}</span></a>
                },
                //{
                //    title: 'Sample Space',
                //    dataIndex: 'sampleSpace',
                //    key: 'sampleSpace',
                //    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value)}</span>
                //    // sorter: true
                //},
                {
                    title: "Rider's Name",
                    dataIndex: 'riderName',
                    key: 'riderName',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value)}</span>
                    // sorter: true
                },
                {
                    title: "Rider's Phone Number",
                    dataIndex: 'riderPhoneNumber',
                    key: 'riderPhoneNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value)}</span>
                    // sorter: true
                },
                {
                    title: "PCR Lab",
                    dataIndex: 'pcrLabName',
                    key: 'pcrLabName',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value)}</span>
                    // sorter: true
                },
                {
                    title: 'Date Generated',
                    dataIndex: 'dateCreated',
                    key: 'dateCreated',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Test Type',
                    dataIndex: 'testType',
                    key: 'testType',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value)}</span>
                    // sorter: true
                },
                {
                    title: 'Date Schedule For Pickup',
                    dataIndex: 'dateScheduleForPickup',
                    key: 'dateScheduleForPickup',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Total Samples Dispatched',
                    dataIndex: 'riderTotalSamplesPicked',
                    key: 'riderTotalSamplesPicked',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,')}</span>
                    // sorter: true
                },
                //{
                //    title: 'Temp. At PickUp',
                //    dataIndex: 'riderTempAtPickUp',
                //    key: 'riderTempAtPickUp',
                //    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-br " key={row.id}>{String(value)}</span>
                //},
                {
                    title: 'Result Status',
                    dataIndex: 'resultStatus',
                    key: 'resultStatus',
                    render: (value: any, row: any, index: any) => <span className={"tb-span " + value && value !== 'pending' ? "db-h3-g" : "db-h3-n"} key={row.id}>{value}</span>
                }
            ];
        const sampleColumns =
            [
                {
                    title: "Patient Id",
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{value}</span>
                    // sorter: true
                },
                {
                    title: 'Sample Id',
                    dataIndex: 'sampleId',
                    key: 'sampleId',
                    render: (value: any, row: any, index: any) => <a className="anchor-action db-h3-b" key={row.id} style={{ cursor: 'pointer' }}><span >{value}</span></a>
                },
                {
                    title: "Indication for VL Test",
                    dataIndex: 'indicationVlTest',
                    key: 'indicationVlTest',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{value && value !== undefined && value !== null ? value : ''}</span>
                    // sorter: true
                },
                {
                    title: "Sample Collection Date",
                    dataIndex: 'sampleCollectedDate',
                    key: 'sampleCollectedDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Date Sent to PCR Lab',
                    dataIndex: 'dateSampleSent',
                    key: 'dateSampleSent',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Date Received at PCR Lab',
                    dataIndex: 'dateSampleReceivedAtPcrLab',
                    key: 'dateSampleReceivedAtPcrLab',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Sample Testable',
                    dataIndex: 'sampleTestable',
                    key: 'sampleTestable',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{value && value !== undefined && value !== null ? value : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Result Status',
                    dataIndex: 'sampleStatus',
                    key: 'sampleStatus',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{value && value !== undefined && value !== null ? value : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Test Result',
                    dataIndex: 'testResult',
                    key: 'testResult',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-br " key={row.id}>{value && value !== undefined && value !== null ? String(value).replace(/(.)(?=(\d{3})+$)/g, '$1,') : ''}</span>
                },
                {
                    title: 'Date Result Dispatched',
                    dataIndex: 'dateResultDispatched',
                    key: 'dateResultDispatched',
                    render: (value: any, row: any, index: any) => <span className="tb-span db-h3-i" key={row.id}>{(value && value !== null) ? value.replace('T00:00:00', '') : ''}</span>
                    // sorter: true
                },
                {
                    title: 'Date Received at Facility',
                    dataIndex: 'dateReceivedAtFacility',
                    key: 'dateReceivedAtFacility',
                    render: (value: any, row: any, index: any) => <span className={"tb-span " + value && value !== 'pending' ? "db-h3-g" : "db-h3-n"} key={row.id}>{value}</span>
                }
            ];

        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR :: LIMS-EMR</title>
                </Helmet>

                <Row style={{ marginTop: '2px' }}>
                    <Col span={24}>
                        <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>LIMS-EMR</h4>
                    </Col>
                </Row>
                <Row gutter={2} style={{ marginTop: '10px', paddingBottom: '10px', display: showDetails ? 'none' : 'flex' }} id="srchDv">
                    {!user.stateCode && <Col xs={24} sm={24} md={6} lg={6}>
                        <Select className="circl-radius top-10-margin"
                            labelInValue
                            showSearch
                            optionFilterProp="children"
                            disabled={loading}
                            //@ts-ignore
                            value={{ key: state.stateId }}
                            style={{ width: '100%' }}
                            placeholder="Select State"
                            onChange={(value) => this.selectState(value)}
                        >
                            <Option key={0} value={0}>-- Select State --</Option>
                            {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                        </Select>
                    </Col>}
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} style={{ marginLeft: '5px' }}>
                        <Select className="top-10-margin"
                            labelInValue
                            showSearch
                            optionFilterProp="children"
                            disabled={loading}
                            style={{ width: '100%' }}
                            //@ts-ignore
                            value={{ key: searchObj.site }}
                            placeholder="Select Site"
                            onChange={(value) => this.selectSite(value)}
                        >
                            <Option key={0} value={0}>-- Select Site --</Option>
                            {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={3} xl={3}>
                        <Button id="searchBtnP" disabled={loading} className="login-button lgn-bttn-2 top-10-margin" type="primary" size="large"
                            onClick={() => this.getItems()} style={{ float: 'left', marginLeft: '10px', width: '100%' }}>
                            <BarsOutlined /> {loading ? 'Please wait...' : 'Fetch Manifests'}
                        </Button>
                    </Col>
                </Row>
                <br />
                <Row gutter={2} style={{ marginTop: '10px', paddingBottom: '10px', display: showDetails ? 'none' : 'flex' }}>
                    <Col xs={24} sm={24} md={3} lg={3}>
                        <Select className="top-10-margin" defaultValue="10" id="pageSize" onChange={(v) => this.handleChange(v)}>
                            <Option value="10">10</Option>
                            <Option value="25">25</Option>
                            <Option value="50">50</Option>
                            <Option value="100">100</Option>
                        </Select>
                    </Col>
                    <Col xs={24} sm={24} md={4} lg={4}>
                        <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search by Manifest ID" value={searchText} onChange={(s) => el.onInputChange(s)} onPressEnter={() => el.onSearch()} />

                    </Col>
                    <Col xs={24} sm={24} md={4} lg={4}>
                        <Button disabled={loading} className="login-button top-10-margin" id="push-btn" key="submit" size="large" onClick={() => this.onSearch()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'left', marginLeft: '5px', width: '100%' }} icon={<SearchOutlined />}>
                            <span id="buttonText">Search Manifest</span>
                        </Button>
                    </Col>
                </Row>
                <Row gutter={2}>
                    <Col span={24} style={{ overflow: "scroll" }}>
                        <Table style={{ marginTop: '10px', paddingBottom: '10px', display: showDetails ? 'none' : '' }} columns={columns} rowKey={record => record.id} dataSource={manifests} pagination={el.state.pagination} loading={el.state.loading} onChange={(a: any, b: any, c: any) => el.handleTableChange(a, b, c)} bordered />
                    </Col>
                </Row>                
                <div className="ul-nfo custom-filter-dropdown" style={{ display: showDetails ? 'block' : 'none' }}>
                    <div className="ant-modal-content">
                        <button title="Close" type="button" aria-label="Close" onClick={() => el.exit()} className="ant-modal-close">
                            <span className="ant-modal-close-x">
                                <CloseCircleOutlined />
                            </span>
                        </button>
                        <div className="ant-modal-header">
                            <div className="ant-modal-title">
                                Manifest Details
                            </div>
                        </div>
                        <Card className="ant-card-body pfs s-list">
                            <div className="ant-modal-body c-form">
                                <form className="ant-form ant-form-horizontal ul-nfo h5">
                                    <Row>
                                        <Col span={12} className="rightBorder">
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Manifest ID:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.manifestId}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Date Generated:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.dateCreated ? manifest.dateCreated.replace('T00:00:00', '') : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Test Type:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.testType ? manifest.testType.toUpperCase() : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Referring Lab State:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.referringLabState ? manifest.referringLabState : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Referring Lab L.G.A:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.referringLabLga ? manifest.referringLabLga : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Total Samples Picked:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.riderTotalSamplesPicked ? manifest.riderTotalSamplesPicked : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>PCR Lab. Name:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.pcrLabName ? manifest.pcrLabName : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Rider's Details:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.riderName ? manifest.riderName + (manifest.riderPhoneNumber && manifest.riderPhoneNumber.length > 0 ? '(' + manifest.riderPhoneNumber + ')' : '') : ''}</h5>
                                                </div>
                                            </div>
                                            <div className="ant-row">
                                                <div className="ant-col-8 padding-md">
                                                    <label>Result Status:</label>
                                                </div>
                                                <div className="ant-col-16 padding-md text-align-left">
                                                    <h5>{manifest.resultStatus ? manifest.resultStatus : ''}</h5>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                        </Card>
                        <div className="ant-modal-footer cl-ant">
                            <div className="ul-nfo custom-filter-dropdown  pt-list">
                                <div className="ant-modal-content">
                                    <div className="ant-modal-header">
                                        <div className="hdr-h" style={{ fontSize: '23px !important' }}>
                                            Samples
                                            </div>
                                    </div>
                                    <div className="ant-modal-body">
                                        <div className='ant-row'>
                                            <div className='ant-col-24 padding-md pt-details'>
                                                <Table columns={sampleColumns} rowKey={record => record.id} dataSource={manifest.manifestSamples} loading={el.state.loading} bordered />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(LimsManifest as any);
